import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,formatDate,DownloadFile } from './Function';
import { Row,Col,Card,Accordion,Tab,Tabs,Table,Button,Placeholder,Form } from 'react-bootstrap';
const TimeTablesArchive = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programTypes,setTypes]=useState([]);
    const[isLoading, setLoading] = useState(true);
    useEffect(()=>
    {
        const getProgramType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programsType/all");
                const result = await response.json();
                setTypes(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('Program Type : Result',result); }
            } catch (error) 
            {
                console.error('Program Type : Error', error.message);
            }
        };
        getProgramType();
    },[])
    return (
        <Card className='mb-4'>
            <Card.Header className='text-center fs-3'>{appLanguage === 'hi' ? 'समय सारणी' : 'TIME TABLES'}</Card.Header>
            <Card.Body>
            {isLoading ? (  
                <Accordion defaultActiveKey={[0]} alwaysOpen>
                    {[...Array(3)].map((_, index)=>(
                    <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header><Placeholder xs={6} /></Accordion.Header>
                        <Accordion.Body>
                            <Tabs defaultActiveKey="0">
                            {[...Array(5)].map((_, index)=>(
                            <Tab eventKey={index} key={index} title={<Placeholder xs={10} />}>
                                <Card className=' mb-3'>
                                    <Card.Body>
                                        <div className='mb-2 fw-bold'><Placeholder xs={3} /></div>
                                        <Row>
                                            <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                                                <Placeholder xs={12} />
                                            </Col>
                                            <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                                                <Placeholder xs={12} />
                                            </Col>
                                            <Col md={4} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                                <Button className='btn btn-info' type='submit'><Placeholder xs={12} /></Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                                <thead>
                                    <tr>
                                        <th className="w-50"><Placeholder xs={12} /></th>
                                        <th><Placeholder xs={12} /></th>
                                        <th><Placeholder xs={12} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {[...Array(10)].map((_,index)=>(
                                <tr key={index}>
                                    <th className="table-success"><Placeholder xs={12} /></th>
                                    <td className="text-center">
                                        <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                                    </td>
                                    <td><Placeholder xs={12} /></td>
                                </tr>
                                ))}
                                </tbody>
                            </Table>                                   
                            </Tab>
                            ))}
                            </Tabs>
                        </Accordion.Body>
                    </Accordion.Item>
                    ))}
                </Accordion>
                ) : (
                <Accordion defaultActiveKey={[0]} alwaysOpen>
                    {programTypes.map((pt,index)=>(
                    <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header>
                            {appLanguage === 'hi' ? (pt.pt_display_en === "1" ? pt.pt_name_hi || '' : pt.pt_name_hi || pt.pt_name) : pt.pt_name}
                        </Accordion.Header>
                        <Accordion.Body>
                            <Programs ptId={pt.pt_id} />
                        </Accordion.Body>
                    </Accordion.Item>
                    ))}
                </Accordion>
                )}
            </Card.Body>
        </Card>
    );
}
export default TimeTablesArchive;
const Programs = ({ptId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programs,setPrograms]=useState([]);
    useEffect(()=>
    {
        const getPrograms = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programs/programType/"+ptId);
                const result = await response.json();
                setPrograms(result);
                if( global.config.IsPrint === true ) { console.info('Programs : Result',result); }
              
            } catch (error) 
            {
                console.error('Programs : Error', error.message);
            }
        };
        getPrograms();    
    },[ptId])
    return (
        <Tabs defaultActiveKey="0">
        {programs.map((p,index)=>(
            <Tab eventKey={index} key={index} title={appLanguage === 'hi' ? (p.p_display_en === "1" ? p.p_short_name_hi || '' : p.p_short_name_hi || p.p_short_name) : p.p_short_name}>
                <TimeTablesByProgram pId={p.p_id} />                                   
            </Tab>
        ))}
        </Tabs>
    );
}
const TimeTablesByProgram = ({pId}) =>
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[TimeTables,setTimeTables]=useState([]);
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        TimeTablesList();
        // eslint-disable-next-line 
    },[pId])
    const TimeTablesList = async (e) => 
    {
        if (e)
        {
            e.preventDefault();
            if (year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        try 
        {
            setLoading(true);
            const { startDate, endDate } = setDateRange(year, month, 0, 1, 0);
            const callApi = global.config.API_URL + `timeTable/list/${pId}/${startDate}/${endDate}`;
            if(global.config.IsPrint) console.info('TimeTablesList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if( result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ptt_id + "/pttTimeTable")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ptt_id + "/pttTimeTableHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].pttTimeTable = el.upp;
                        result[i].pttTimeTableHi = el.upph;                            
                    });
                    setTimeTables(result);
                    setLoading(false);
                }).catch(error => {
                    console.error('TimeTablesList File :', error);
                    setLoading(false);
                });
            }
            else
            {
                setTimeTables([]);
                setLoading(false);            
            }
            if( global.config.IsPrint === true ) { console.info('TimeTablesList : Result',result); }
        }
        catch (error) { 
            console.error('TimeTablesList : Error', error.message);
            setLoading(false);
        }
    };
    return (
    <React.Fragment>
        <Card className=' mb-3'>
            <Card.Body>
                <form onSubmit={TimeTablesList}>
                    <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                    <Row className='g-2'>
                        <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                            <Form.Select onChange={YearChange} value={year}>
                                <option value={0}>{t('FilterYear')}</option>
                                {setYearList(0,1).map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                            <Form.Select onChange={MonthChange} value={month}>
                                <option value={0}>{t('FilterMonth')}</option>
                                {setMonthList().map(({ value, label }) => (
                                <option key={value} value={value}>
                                    {label}
                                </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={4} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                            <Button className='btn btn-info' type='submit'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                        </Col>
                    </Row>
                </form>
            </Card.Body>
        </Card>
        <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
        <thead>
            <tr>
                <th className="w-50">{t('Title')}</th>
                <th>{t('UploadDate')}</th>
                <th>{t('Download')}</th>
            </tr>
        </thead>
        {isLoading ? (
        <tbody>
            {[...Array(5)].map((_, index) => (
            <tr key={index}>
                <th className="table-success"><Placeholder xs={12} /></th>                
                <td><Placeholder xs={12} /></td>
                <td className="text-center">
                    <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                </td>
            </tr>
            ))}
        </tbody>
        ) : (
        <tbody>
            {TimeTables.map((ptt,index)=>(
            <tr key={index}>
                <th className="table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (ptt.ptt_display_en === "1" ? ptt.ptt_name_hi || '' : ptt.ptt_name_hi || ptt.ptt_name) : ptt.ptt_name}}></th>                
                <td>{formatDate(ptt.ptt_date)}</td>
                <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,ptt.pttTimeTable,ptt.pttTimeTableHi)}} />
            </tr>
            ))}
        </tbody>
        )}
        </Table>
    </React.Fragment>
    );
}